(function(){
'use strict';
if(window.__lovenAvailSearchBarInit)return;
window.__lovenAvailSearchBarInit=true;
  var months=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  var cur=new Date();cur.setDate(1);
  var startD=null,endD=null,step=0;
  var selectedCollection='search';
  var collections=[];
  /** Toujours relire le DOM : après filtre AJAX / section reload, l’ancien #as-where-input est détaché et les listeners ne tournaient plus. */
  function getAvailSearchEl(){ return document.getElementById('avail-search'); }
  function getWhereInputEl(){ return document.getElementById('as-where-input'); }
  function getWhereWrapEl(){ return document.getElementById('as-where-wrap'); }
  var dropdown=document.getElementById('as-dropdown'),toggle=document.getElementById('as-toggle'),display=document.getElementById('as-display'),clearBtn=document.getElementById('as-clear');
  var colToggle=document.getElementById('as-col-toggle'),colDropdown=document.getElementById('as-col-dropdown');
  var destSuggestions=document.createElement('div');
  destSuggestions.id='as-dest-suggestions';
  destSuggestions.className='as-dest-suggestions';
  destSuggestions.setAttribute('aria-hidden','true');
  var destLat=null,destLon=null,destRadiusKm=null,destDebounceTimer=null,destFetchSeq=0;
  var LOVEN_RECENT_DEST_KEY='loven_dest_recent_v1';
  /** Villes / régions fréquentes (coords fixes) — affichées au focus sans frappe. */
  var LOVEN_POPULAR_DESTINATIONS=[
    {display_place:'Paris',display_address:'Île-de-France',lat:'48.8566',lon:'2.3522'},
    {display_place:'Lyon',display_address:'Auvergne-Rhône-Alpes',lat:'45.7640',lon:'4.8357'},
    {display_place:'Marseille',display_address:"Provence-Alpes-Côte d'Azur",lat:'43.2965',lon:'5.3698'},
    {display_place:'Bordeaux',display_address:'Nouvelle-Aquitaine',lat:'44.8378',lon:'-0.5792'},
    {display_place:'Lille',display_address:'Hauts-de-France',lat:'50.6292',lon:'3.0573'},
    {display_place:'Nice',display_address:"Provence-Alpes-Côte d'Azur",lat:'43.7102',lon:'7.2620'},
    {display_place:'Bruxelles',display_address:'Belgique',lat:'50.8503',lon:'4.3517'}
  ];
  /** Biais géographique France + Belgique (LocationIQ / Nominatim : pondère les résultats dans la zone sans tout exclure). */
  var LIQ_VIEWBOX_FR_BE='-5.5,41,10.1,51.6';

  /**
   * Rayons de filtre geo (km) selon le type de lieu — surcharge optionnelle :
   *   window.__lovenDestRadius = { cityKm: 50, villageKm: 40, departmentKm: 90, regionKm: 180, countryKm: 500, defaultKm: 50, nearMeKm: 50 }
   */
  function numOr(x, d) {
    var n = Number(x);
    return isNaN(n) || n <= 0 ? d : n;
  }
  function getLovenRadiusProfile() {
    var w = window.__lovenDestRadius || {};
    return {
      city: numOr(w.cityKm, 50),
      village: numOr(w.villageKm, 40),
      department: numOr(w.departmentKm, 90),
      region: numOr(w.regionKm, 180),
      country: numOr(w.countryKm, 500),
      defaultKm: numOr(w.defaultKm, 50),
      nearMe: numOr(w.nearMeKm, 50),
    };
  }
  function clampRadiusKm(r) {
    var n = Number(r);
    if (isNaN(n) || n <= 0) return getLovenRadiusProfile().defaultKm;
    return Math.min(500, Math.max(5, n));
  }
  /** Heuristique Nominatim / LocationIQ (class, type, address). */
  function radiusKmFromLiqHit(it) {
    if (!it) return getLovenRadiusProfile().defaultKm;
    var p = getLovenRadiusProfile();
    var cls = String(it.class || '').toLowerCase();
    var typ = String(it.type || '').toLowerCase();
    var addr = it.address || {};
    var label = String(it.display_name || it.name || '').toLowerCase();
    var hasCityLike = !!(addr.city || addr.town || addr.village || addr.municipality || addr.hamlet);
    var looksDepartment =
      typ === 'county' ||
      label.indexOf('département') !== -1 ||
      label.indexOf('departement') !== -1;
    if (typ === 'country' || typ === 'continent') return clampRadiusKm(p.country);
    if (typ === 'state' || typ === 'region' || typ === 'province') return clampRadiusKm(p.region);
    if (typ === 'state_district' || typ === 'macroregion' || typ === 'archipelago') return clampRadiusKm(p.region);
    if (typ === 'district') return clampRadiusKm(p.department);
    if (looksDepartment) return clampRadiusKm(p.department);
    /**
     * Limite administrative d’une commune (ex. Paris, relation OSM) : class=boundary, type=administrative.
     * Avec champs d’adresse de commune — rayon « ville » (souvent 50 km), pas « région » (~180–200 km).
     */
    if (cls === 'boundary' && typ === 'administrative') {
      if (hasCityLike) {
        return clampRadiusKm(p.city);
      }
      return clampRadiusKm(p.department);
    }
    if (typ === 'administrative' && (addr.city || addr.town || addr.municipality)) {
      return clampRadiusKm(p.city);
    }
    if (typ === 'administrative') {
      return clampRadiusKm(p.department);
    }
    if (!hasCityLike && (addr.state || addr.region) && typ !== 'house' && typ !== 'building' && typ !== 'road' && typ !== 'pedestrian') {
      return clampRadiusKm(p.department);
    }
    if (typ === 'hamlet' || typ === 'neighbourhood' || typ === 'suburb' || typ === 'quarter' || typ === 'village') return clampRadiusKm(p.village);
    if (typ === 'town' || typ === 'city' || typ === 'locality') return clampRadiusKm(p.city);
    if (typ === 'municipality') return clampRadiusKm(hasCityLike ? p.city : p.region);
    return clampRadiusKm(p.defaultKm);
  }

  if(dropdown) document.body.appendChild(dropdown);
  if(colDropdown) document.body.appendChild(colDropdown);
  /* Voir ensureDestSuggestionsMount : dans #HeaderWrapper (sous le méga-menu) sauf collection/recherche embarquée */
  ensureDestSuggestionsMount();

  /*
   * Enregistré tout de suite : si une ligne plus bas lève (toggle / as-prev / as-search absents),
   * l’autocomplete ne doit pas rester sans listeners.
   */
  document.addEventListener('input', function(e){
    var t=e.target;
    var wi=t&&(t.id==='as-where-input'?t:t.closest&&t.closest('#as-where-input'));
    if(!wi||wi.id!=='as-where-input')return;
    var wcb=document.getElementById('as-where-clear');
    if(wcb)wcb.hidden=!(wi.value||'').trim();
    destLat=null;
    destLon=null;
    destRadiusKm=null;
    selectedCollection='search';
    clearTimeout(destDebounceTimer);
    var q=(wi.value||'').trim();
    if(q.length<2){
      destDebounceTimer=setTimeout(showDestinationInitialPanel,0);
      return;
    }
    var cfg=getLiqConfig();
    if(!cfg.token){closeDestSuggestions();return;}
    destDebounceTimer=setTimeout(runDestAutocomplete,350);
  });

  document.addEventListener('focusin', function(e){
    var t=e.target;
    var wi=t&&(t.id==='as-where-input'?t:t.closest&&t.closest('#as-where-input'));
    if(!wi||wi.id!=='as-where-input')return;
    if(isLovenMobileSearchUi())closeDates();
    openDestinationSearchPanel();
  });

  document.addEventListener('focusin', function(e){
    if(!isLovenMobileSearchUi())return;
    var tb=e.target.closest&&e.target.closest('#as-toggle');
    if(!tb)return;
    closeDestSuggestions();
    closeCollections();
    if(dropdown&&!dropdown.classList.contains('open'))openDates();
  });

  document.addEventListener('pointerdown', function(e){
    if(!isLovenMobileSearchUi())return;
    var t=e.target;
    if(!t||!t.closest)return;
    if(t.closest('#as-dropdown'))return;
    if(t.closest('#as-dest-suggestions'))return;
    if(t.closest('#as-col-dropdown'))return;
    if(t.closest('#as-where-wrap')||t.closest('#as-where-input')){
      closeDates();
      closeCollections();
    }else if(t.closest('#as-toggle')){
      closeDestSuggestions();
      closeCollections();
    }
  }, true);

  document.addEventListener('keydown', function(e){
    var t=e.target;
    var wi=t&&(t.id==='as-where-input'?t:t.closest&&t.closest('#as-where-input'));
    if(!wi||wi.id!=='as-where-input')return;
    if(e.key==='Escape')closeDestSuggestions();
  });

  document.addEventListener('click', function(e){
    var inner=e.target.closest&&e.target.closest('#as-where-inner');
    if(!inner)return;
    if(e.target.closest&&e.target.closest('.as-where-clear'))return;
    var win=document.getElementById('as-where-input');
    if(win)win.focus();
  });

  document.addEventListener('click', function(e){
    var btn=e.target.closest&&e.target.closest('#as-where-clear');
    if(!btn)return;
    e.preventDefault();
    e.stopPropagation();
    var win=document.getElementById('as-where-input');
    if(!win)return;
    win.value='';
    destLat=null;
    destLon=null;
    destRadiusKm=null;
    btn.hidden=true;
    selectedCollection='search';
    renderCollections();
    /* La croix ferme le panneau (ne pas refocus → focusin rouvrait les suggestions). */
    closeDestSuggestions();
    if(document.activeElement===win)win.blur();
  });

  document.addEventListener('shopify:section:load', function(){
    ensureDestSuggestionsMount();
    hydrateDestFromUrl();
    hydrateCollectionFromUrl();
    renderCollections();
  });

  function pad(n){return n<10?'0'+n:n;}
  function fmtShort(d){return pad(d.getDate())+' '+months[d.getMonth()].substring(0,3).toLowerCase()+'.';}
  function isoDate(d){return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate());}
  function sameDay(a,b){return a&&b&&a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate();}
  function clamp(value,min,max){return Math.max(min,Math.min(max,value));}
  function isLovenMobileSearchUi(){
    try{
      return typeof window.matchMedia==='function'&&window.matchMedia('(max-width: 768px)').matches;
    }catch(e){return false;}
  }

  /** Handle collection courante depuis l’URL (null hors page collection). */
  function getCollectionHandleFromPath(){
    var m=(window.location.pathname||'').match(/\/collections\/([^/]+)/);
    return m?decodeURIComponent(m[1]):null;
  }

  /** Reprend les paramètres Shopify Search & Discovery (filter.*). */
  function appendFilterParamsFromUrl(sourceUrl,targetParams){
    sourceUrl.searchParams.forEach(function(val,key){
      if(key.indexOf('filter.')===0)targetParams.append(key,val);
    });
  }

  function withLocationHash(pathAndQuery){
    var h=window.location.hash||'';
    return pathAndQuery+h;
  }

  /**
   * Rechercher : destination + dates optionnelles + tri + facettes si même collection que l’URL actuelle
   * (sinon pas de facettes héritées d’une autre région). Pagination non recopiée (nouvelle requête = page 1).
   */
  function buildSearchUrl(colHandle,sd,ed){
    var u=new URL(window.location.href);
    var cur=getCollectionHandleFromPath();
    var same=cur===colHandle;
    var next=new URL(u.origin+'/collections/'+encodeURIComponent(colHandle));
    if(sd&&ed){
      next.searchParams.set('start',isoDate(sd));
      next.searchParams.set('end',isoDate(ed));
    }
    var sort=u.searchParams.get('sort_by');
    if(sort)next.searchParams.set('sort_by',sort);
    if(same)appendFilterParamsFromUrl(u,next.searchParams);
    if(destLat!=null&&destLon!=null&&!isNaN(destLat)&&!isNaN(destLon)){
      next.searchParams.set('dest_lat',String(destLat));
      next.searchParams.set('dest_lon',String(destLon));
      var radOut=destRadiusKm!=null&&!isNaN(destRadiusKm)?clampRadiusKm(destRadiusKm):getLovenRadiusProfile().defaultKm;
      next.searchParams.set('dest_radius_km',String(radOut));
    }
    var wi0=getWhereInputEl();
    var destLab=wi0?(wi0.value||'').trim():'';
    if(destLab){next.searchParams.set('dest_label',destLab);}
    return withLocationHash(next.pathname+next.search);
  }

  /**
   * Sans suggestion cliquée : si « Toutes les régions » + texte dans la barre + jeton API,
   * appelle l’API Search LocationIQ pour obtenir dest_lat/dest_lon avant de construire l’URL.
   */
  function resolveDestinationBeforeSearch(){
    return new Promise(function(resolve){
      var cfg=getLiqConfig();
      var wiS=getWhereInputEl();
      var q=wiS?(wiS.value||'').trim():'';
      if(destLat!=null&&destLon!=null&&!isNaN(destLat)&&!isNaN(destLon)){resolve();return;}
      if((selectedCollection||'search')!=='search'){resolve();return;}
      if(!q||q.length<2){resolve();return;}
      if(!cfg.token){resolve();return;}
      var params=new URLSearchParams();
      params.set('key',cfg.token);
      params.set('q',q);
      params.set('format','json');
      params.set('limit','1');
      params.set('accept-language','fr');
      params.set('addressdetails','1');
      params.set('dedupe','1');
      if(cfg.countrycodes)params.set('countrycodes',cfg.countrycodes);
      applyLiqViewboxParams(params);
      var endpoints=['https://eu1.locationiq.com/v1/search','https://api.locationiq.com/v1/search'];
      var i=0;
      function trySearch(){
        if(i>=endpoints.length){resolve();return;}
        fetch(endpoints[i]+'?'+params.toString(),getLocationIqFetchInit())
          .then(function(r){return r.text().then(function(t){return {ok:r.ok,status:r.status,text:t};});})
          .then(function(res){
            var data;
            try{data=JSON.parse(res.text);}catch(e){i++;trySearch();return;}
            if(!res.ok||!Array.isArray(data)||!data.length){i++;trySearch();return;}
            var first=data[0];
            if(first.lat!=null&&first.lon!=null){
              destLat=parseFloat(String(first.lat),10);
              destLon=parseFloat(String(first.lon),10);
              destRadiusKm=radiusKmFromLiqHit(first);
            }
            resolve();
          })
          .catch(function(){i++;trySearch();});
      }
      trySearch();
    });
  }

  /** Nettoie le jeton (espaces, retours ligne, caractères invisibles du copier-coller). */
  function sanitizeLocationIqToken(raw){
    if(raw==null||raw==='')return'';
    var s=String(raw);
    s=s.replace(/[\u200B-\u200D\uFEFF\u00A0]/g,'');
    s=s.replace(/\s+/g,'');
    return s.trim();
  }

  function getLiqConfig(){
    var cfg=window.__locationIq||{};
    return {
      token:sanitizeLocationIqToken(cfg.token||''),
      countrycodes:(cfg.countrycodes||'fr,be').trim()
    };
  }

  /** Message d’erreur API détaillé : réservé au debug (réglage thème ou ?loven_debug=1), pas aux visiteurs. */
  function shouldShowLocationIqTechnicalUi(){
    try{
      if(window.__lovenShowDebugPanel)return true;
      return /\bloven_debug=1\b/.test(String(window.location&&window.location.search||''));
    }catch(e){return false;}
  }

  /**
   * Chaîne de comparaison (libellé suggestion) : casse, espaces, accents.
   * Pas de NFD : fallback navigateurs sans Intl.
   */
  function normalizeDedupeString(s){
    if(s==null||s==='')return '';
    var t=String(s).toLowerCase().replace(/\s+/g,' ').trim();
    try{
      if(t.normalize) t=t.normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    }catch(e){}
    t=t.replace(/[’'´`]/g,"'");
    return t;
  }

  /**
   * Rues, bâtiments, quartiers, etc. : on ne les regroupe pas par (titre, pays) pour ne pas
   * mélanger avec la ville hôte (ex. 16e reste listé).
   */
  function isLiqTypeMergedByTitleAndCountry(it){
    if(!it||typeof it!=='object')return false;
    var t=String(it.type||'').toLowerCase();
    if(!t) return true;
    var notMerge={
      suburb:1, neighbourhood:1, quarter:1, residential:1, road:1, house:1, building:1, pedestrian:1, hamlet:1,
      isolated_dwelling:1, farm:1, pitch:1, farmyard:1, yes:1
    };
    return !notMerge[t];
  }

  /**
   * Après fusion search/autocomplete (clés place_id / OSM) : plusieurs nœuds/relation
   * « Paris » (FR) coexistent. On garde la première entrée (ordre API + importancesort), une par
   * (titre affichable normalisé + code pays) pour les types « agglomération » ; pas d’écrasement
   * des lignes strictement identiques (dédupliqué avant, ou quartiers avec même ville).
   */
  function dedupeLiqDestHits(merged){
    if(!Array.isArray(merged)||!merged.length)return merged;
    var exactSeen=Object.create(null);
    var tccSeen=Object.create(null);
    var out=[];
    for(var i=0;i<merged.length;i++){
      var it=merged[i];
      var fd=formatDestSuggestion(it);
      var t=normalizeDedupeString(fd.title);
      var s=normalizeDedupeString(fd.sub);
      var exactK=t+'\n'+s;
      if(exactSeen[exactK]) continue;
      if(isLiqTypeMergedByTitleAndCountry(it)){
        var cc=((it.address||{}).country_code||'').toLowerCase();
        if(t&&cc){
          var tccK=t+'\0'+cc;
          if(tccSeen[tccK]) continue;
          tccSeen[tccK]=1;
        }
      }
      exactSeen[exactK]=1;
      out.push(it);
    }
    return out;
  }

  /** Fusionne search + autocomplete, déduplique, place d’abord les pays ciblés par countrycodes (évite que seuls des « parc » étrangers remontent). */
  function mergeAndRankDestHits(searchList, autoList, cfg){
    var a=Array.isArray(searchList)?searchList:[];
    var b=Array.isArray(autoList)?autoList:[];
    var pref=(cfg&&cfg.countrycodes?cfg.countrycodes:'fr,be').split(',').map(function(x){return x.trim().toLowerCase();}).filter(Boolean);
    if(!pref.length)pref=['fr','be'];
    var seen={}, ordered=[];
    function hitKey(it){
      if(it==null)return '';
      if(it.place_id!=null&&String(it.place_id)!=='')return 'p:'+String(it.place_id);
      return 'k:'+String(it.osm_type)+':'+String(it.osm_id)+':'+String(it.lat)+':'+String(it.lon);
    }
    function pushUnique(it){
      var k=hitKey(it);
      if(!k||seen[k])return;
      seen[k]=1;
      ordered.push(it);
    }
    var n=Math.max(a.length,b.length);
    for(var i=0;i<n;i++){
      if(a[i])pushUnique(a[i]);
      if(b[i])pushUnique(b[i]);
    }
    var good=[], rest=[];
    ordered.forEach(function(it){
      var cc=((it.address||{}).country_code||'').toLowerCase();
      if(pref.indexOf(cc)>=0)good.push(it);
      else rest.push(it);
    });
    return good.concat(rest).slice(0,15);
  }

  function applyLiqViewboxParams(params){
    params.set('viewbox',LIQ_VIEWBOX_FR_BE);
    params.set('bounded','0');
  }

  /** Réponse attendue = tableau ; certains cas / proxies renvoient un objet — on normalise. */
  function normalizeLocationIqAutocomplete(data){
    if(data==null)return null;
    if(Array.isArray(data))return data.length?data:null;
    if(typeof data==='object'&&data.error)return null;
    if(Array.isArray(data.results))return data.results.length?data.results:null;
    return null;
  }

  /**
   * Forward Geocoding (/v1/search) — même famille que « Rechercher ».
   * Souvent autorisée quand /v1/autocomplete est exclu du forfait ou bloquée en navigateur.
   */
  function normalizeLocationIqSearchHits(data){
    if(data==null)return null;
    if(Array.isArray(data))return data.length?data:null;
    if(typeof data==='object'&&data.error)return null;
    return null;
  }

  function getRecentDestinations(){
    try{
      var raw=localStorage.getItem(LOVEN_RECENT_DEST_KEY);
      if(!raw)return [];
      var arr=JSON.parse(raw);
      if(!Array.isArray(arr))return [];
      return arr.filter(function(x){
        return x&&x.label&&x.lat!=null&&x.lon!=null&&!isNaN(parseFloat(x.lat,10))&&!isNaN(parseFloat(x.lon,10));
      }).slice(0,8);
    }catch(e){return [];}
  }

  function saveRecentDestination(o){
    if(!o||!o.label)return;
    var lat=parseFloat(String(o.lat),10),lon=parseFloat(String(o.lon),10);
    if(isNaN(lat)||isNaN(lon))return;
    var list=getRecentDestinations().filter(function(x){return x.label!==o.label;});
    var entry={label:o.label,lat:lat,lon:lon,sub:o.sub||''};
    if(o.rad!=null&&!isNaN(Number(o.rad)))entry.rad=clampRadiusKm(Number(o.rad));
    list.unshift(entry);
    list=list.slice(0,5);
    try{localStorage.setItem(LOVEN_RECENT_DEST_KEY,JSON.stringify(list));}catch(e){}
  }

  /** Retire un numéro de voie en tête du libellé (ex. « 12 rue … » → « rue … »). */
  function stripLeadingStreetNumber(s){
    if(!s)return '';
    var t=String(s).replace(/\s+/g,' ').trim();
    var out=t.replace(/^\d{1,5}[a-zA-Z\u00b0]?\s+/,'');
    return out.trim()||t;
  }

  /**
   * Libellés courts pour la liste (sans numéro de rue sur les adresses).
   * Points d’intérêt : si display_place n’est pas la ville, on garde le nom du lieu.
   * Popularité côté API : importancesort=1 + dedupe (voir runDestAutocomplete).
   */
  function formatDestSuggestion(it){
    var addr=it.address||{};
    var city=addr.city||addr.town||addr.village||addr.municipality||addr.hamlet;
    var region=addr.state||addr.county||addr.region;
    var country=addr.country||'';
    var dp=(it.display_place||'').trim();
    var da=(it.display_address||'').trim();
    var dn=(it.display_name||'').trim();
    var headFirst=(dp.split(',')[0]||dp||'').trim();
    if(headFirst&&city&&headFirst.indexOf(city)<0){
      return {title:stripLeadingStreetNumber(headFirst),sub:da||(city?[city,region,country].filter(Boolean).join(', '):'')};
    }
    if(city){
      var title=city;
      var subBits=[];
      if(addr.house_number&&addr.road)subBits.push(addr.road);
      if(addr.suburb&&addr.suburb!==city)subBits.push(addr.suburb);
      [region,country].forEach(function(x){if(x&&subBits.indexOf(x)<0)subBits.push(x);});
      var sub=subBits.join(', ');
      if(!sub&&it.display_name){
        var p=String(it.display_name).split(',').map(function(x){return x.trim();});
        sub=p.filter(function(x){return x!==city}).slice(0,3).join(', ');
      }
      return {title:title,sub:sub};
    }
    var head=dp||(dn.split(',')[0]||'')||'';
    var title=stripLeadingStreetNumber(head);
    var sub=da||(dn.split(',').slice(1).join(',')||'').trim();
    if(!title||title==='—')title=stripLeadingStreetNumber((dn.split(',')[0]||'')||'')||'—';
    return {title:title||'—',sub:sub||''};
  }

  function createDestSugButtonElement(){
    var btn=document.createElement('button');
    btn.type='button';
    btn.className='as-dest-sug-item';
    btn.setAttribute('role','option');
    btn.innerHTML='<span class="as-dest-sug-pin" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg></span><span class="as-dest-sug-text"><span class="as-dest-sug-title"></span><span class="as-dest-sug-sub"></span></span>';
    return btn;
  }

  function createNearMeButtonElement(){
    var btn=document.createElement('button');
    btn.type='button';
    btn.className='as-dest-sug-item as-dest-sug-item--near';
    btn.setAttribute('role','option');
    btn.innerHTML='<span class="as-dest-sug-pin as-dest-sug-pin--near" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2"/></svg></span><span class="as-dest-sug-text"><span class="as-dest-sug-title">Autour de moi</span><span class="as-dest-sug-sub">Utiliser ma position</span></span>';
    return btn;
  }

  function attachNearMeHandler(btn){
    btn.addEventListener('mousedown',function(e){e.preventDefault();});
    btn.addEventListener('click',function(){
      var cfg=getLiqConfig();
      var subEl=btn.querySelector('.as-dest-sug-sub');
      if(!cfg.token){
        var prev=subEl.textContent;
        subEl.textContent='Configurer le jeton LocationIQ (thème)';
        setTimeout(function(){subEl.textContent=prev;},2800);
        return;
      }
      if(!navigator.geolocation){
        alert('La géolocalisation n’est pas disponible dans ce navigateur.');
        return;
      }
      btn.disabled=true;
      var prevSub=subEl.textContent;
      subEl.textContent='Localisation…';
      navigator.geolocation.getCurrentPosition(
        function(pos){
          var la=pos.coords.latitude, lo=pos.coords.longitude;
          var params=new URLSearchParams();
          params.set('key',cfg.token);
          params.set('lat',String(la));
          params.set('lon',String(lo));
          params.set('format','json');
          params.set('addressdetails','1');
          params.set('accept-language','fr');
          var bases=['https://eu1.locationiq.com/v1/reverse?','https://api.locationiq.com/v1/reverse?'];
          var ix=0;
          function finishNearMe(addrOk){
            btn.disabled=false;
            subEl.textContent=prevSub;
            destLat=la;destLon=lo;
            destRadiusKm=clampRadiusKm(getLovenRadiusProfile().nearMe);
            var city='';
            if(addrOk&&addrOk.address){
              var a=addrOk.address;
              city=a.city||a.town||a.village||a.municipality||a.hamlet||a.suburb||a.county||'';
            }
            var wi=getWhereInputEl();
            if(wi)wi.value='Autour de moi';
            var wcb=document.getElementById('as-where-clear');
            if(wcb)wcb.hidden=false;
            selectedCollection='search';
            saveRecentDestination({label:'Autour de moi',lat:la,lon:lo,sub:city?('Près de '+city):'Position GPS',rad:destRadiusKm});
            renderCollections();
            closeDestSuggestions();
          }
          function tryRev(){
            if(ix>=bases.length){
              finishNearMe(null);
              return;
            }
            fetchLocationIqArray(bases[ix]+params.toString())
              .then(function(data){
                finishNearMe(data);
              })
              .catch(function(){
                ix++;
                tryRev();
              });
          }
          tryRev();
        },
        function(){
          btn.disabled=false;
          subEl.textContent=prevSub;
          alert('Position refusée ou indisponible. Autorisez la localisation dans le navigateur.');
        },
        {enableHighAccuracy:false,timeout:14000,maximumAge:120000}
      );
    });
  }

  function wireDestPick(btn, latStr, lonStr, line, subTail, radiusKmOpt){
    btn.addEventListener('mousedown',function(e){e.preventDefault();});
    btn.addEventListener('click',function(){
      var a=parseFloat(String(latStr),10),b=parseFloat(String(lonStr),10);
      if(isNaN(a)||isNaN(b))return;
      destLat=a;destLon=b;
      destRadiusKm=radiusKmOpt!=null&&!isNaN(Number(radiusKmOpt))?clampRadiusKm(Number(radiusKmOpt)):getLovenRadiusProfile().defaultKm;
      var wi=getWhereInputEl();
      if(wi)wi.value=line;
      var wcb=document.getElementById('as-where-clear');
      if(wcb)wcb.hidden=false;
      selectedCollection='search';
      saveRecentDestination({label:line,lat:destLat,lon:destLon,sub:subTail||'',rad:destRadiusKm});
      renderCollections();
      closeDestSuggestions();
    });
  }

  /** Init fetch LocationIQ : sur http://127.0.0.1 / localhost le navigateur tronque souvent le Referer vers une API HTTPS → la whitelist LocationIQ ne matche pas ; on force referrer + unsafe-url. */
  function getLocationIqFetchInit(){
    var init={
      method:'GET',
      mode:'cors',
      credentials:'omit',
      referrerPolicy:'unsafe-url'
    };
    try{
      var h=window.location&&window.location.hostname;
      if(h==='127.0.0.1'||h==='localhost'||h==='[::1]'){
        init.referrer=window.location.href;
      }
    }catch(e){}
    return init;
  }

  function fetchLocationIqArray(url){
    /*
     * Pas de header Accept: application/json : en CORS cela peut forcer un préflight OPTIONS ;
     * si la réponse préflight échoue, fetch tombe en erreur sans message clair. format=json suffit pour du JSON.
     */
    return fetch(url,getLocationIqFetchInit())
      .then(function(r){
        return r.text().then(function(t){
          var data;
          try{data=JSON.parse(t);}catch(e){
            var ej=new Error('Réponse non-JSON ('+r.status+')');
            ej.httpStatus=r.status;
            ej.rawBody=t?String(t).substring(0,500):'';
            return Promise.reject(ej);
          }
          if(!r.ok){
            var em=new Error((data&&data.error)||('HTTP '+r.status));
            em.httpStatus=r.status;
            em.body=data;
            return Promise.reject(em);
          }
          if(data&&typeof data==='object'&&data.error&&!Array.isArray(data)){
            var eo=new Error(String(data.error));
            eo.httpStatus=r.status;
            eo.body=data;
            return Promise.reject(eo);
          }
          return data;
        });
      });
  }

  /** Collection/recherche embarquée : body + couche haute (barre sticky). Sinon #HeaderWrapper pour rester sous le méga-menu (voir thème .transition-body). */
  function getDestSuggestionsMountEl(){
    if(document.querySelector('.collection-content--embedded-search'))return document.body;
    if(document.body.classList.contains('loven-mobile-search-overlay-active'))return document.body;
    return document.getElementById('HeaderWrapper')||document.body;
  }

  function ensureDestSuggestionsMount(){
    var mount=getDestSuggestionsMountEl();
    var onBody=mount===document.body;
    if(onBody)destSuggestions.classList.add('as-dest-suggestions--layer-body');
    else destSuggestions.classList.remove('as-dest-suggestions--layer-body');
    if(mount&&destSuggestions.parentNode!==mount){
      try{mount.appendChild(destSuggestions);}catch(e){}
    }
  }

  function positionDestSuggestions(){
    var wrap=getWhereWrapEl();
    if(!wrap||!destSuggestions.parentNode)return;
    ensureDestSuggestionsMount();
    var rect=wrap.getBoundingClientRect();
    var viewportWidth=window.innerWidth||document.documentElement.clientWidth||400;
    /* Largeur indépendante de la barre ; bord gauche du panneau = bord gauche du champ (#as-where-wrap) */
    var panelW=Math.min(480,Math.max(220,viewportWidth-24));
    var left=Math.round(clamp(rect.left,12,viewportWidth-panelW-12));
    destSuggestions.style.position='fixed';
    destSuggestions.style.left=left+'px';
    destSuggestions.style.top=Math.round(rect.bottom+8)+'px';
    destSuggestions.style.width='';
    destSuggestions.style.maxWidth='';
    destSuggestions.style.right='auto';
    destSuggestions.style.bottom='auto';
    destSuggestions.style.marginLeft='0';
    destSuggestions.style.marginRight='0';
  }

  function mountDestSuggestionsInWhereWrap(){
    ensureDestSuggestionsMount();
  }

  function closeDestSuggestions(){
    destSuggestions.classList.remove('open');
    destSuggestions.innerHTML='';
    destSuggestions.setAttribute('aria-hidden','true');
    var wi=getWhereInputEl();
    if(wi)wi.setAttribute('aria-expanded','false');
  }

  function appendDestApiAttribution(){
    var foot=document.createElement('div');
    foot.className='as-dest-attribution';
    foot.innerHTML='Données <a href="https://locationiq.com/" target="_blank" rel="noopener noreferrer">LocationIQ</a> · <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>';
    destSuggestions.appendChild(foot);
  }

  /** Message visible si l’API renvoie 401 / clé invalide (ex. jeton Mapbox collé par erreur à la place de LocationIQ). */
  function showDestApiErrorMessage(msg){
    mountDestSuggestionsInWhereWrap();
    destSuggestions.innerHTML='';
    var d=document.createElement('div');
    d.className='as-dest-api-error';
    d.setAttribute('role','alert');
    d.textContent=msg;
    destSuggestions.appendChild(d);
    appendDestApiAttribution();
    destSuggestions.classList.add('open');
    destSuggestions.setAttribute('aria-hidden','false');
    var wi=getWhereInputEl();
    if(wi)wi.setAttribute('aria-expanded','true');
    positionDestSuggestions();
    requestAnimationFrame(function(){
      positionDestSuggestions();
      requestAnimationFrame(positionDestSuggestions);
    });
  }

  function liqErrorLooksAuth(err){
    if(!err)return false;
    if(err.httpStatus===401||err.httpStatus===403)return true;
    var t=String((err.body&&err.body.error)||err.message||'');
    return /invalid\s*key|invalid\s*token|unauthor|401|403/i.test(t);
  }

  function renderDestSuggestionItems(items){
    destSuggestions.innerHTML='';
    items.forEach(function(it){
      var fd=formatDestSuggestion(it);
      var btn=createDestSugButtonElement();
      btn.querySelector('.as-dest-sug-title').textContent=fd.title;
      btn.querySelector('.as-dest-sug-sub').textContent=fd.sub;
      var line=fd.title+(fd.sub?', '+fd.sub:'');
      wireDestPick(btn,it.lat,it.lon,line,fd.sub,radiusKmFromLiqHit(it));
      destSuggestions.appendChild(btn);
    });
    appendDestApiAttribution();
  }

  function showDestinationInitialPanel(){
    destFetchSeq++;
    mountDestSuggestionsInWhereWrap();
    destSuggestions.innerHTML='';
    var recent=getRecentDestinations();
    if(recent.length){
      var h=document.createElement('div');
      h.className='as-dest-section-title';
      h.textContent='Recherches récentes';
      destSuggestions.appendChild(h);
      recent.forEach(function(r){
        var btn=createDestSugButtonElement();
        var parts=r.label.split(',');
        btn.querySelector('.as-dest-sug-title').textContent=(parts[0]||r.label).trim();
        btn.querySelector('.as-dest-sug-sub').textContent=(r.sub||'').trim()||parts.slice(1).join(',').trim();
        wireDestPick(btn,r.lat,r.lon,r.label,r.sub||'',r.rad!=null?r.rad:getLovenRadiusProfile().defaultKm);
        destSuggestions.appendChild(btn);
      });
    }
    var h2=document.createElement('div');
    h2.className='as-dest-section-title';
    h2.textContent='Suggestions de destinations';
    destSuggestions.appendChild(h2);
    var nearBtn=createNearMeButtonElement();
    attachNearMeHandler(nearBtn);
    destSuggestions.appendChild(nearBtn);
    LOVEN_POPULAR_DESTINATIONS.forEach(function(p){
      var btn=createDestSugButtonElement();
      btn.querySelector('.as-dest-sug-title').textContent=p.display_place;
      btn.querySelector('.as-dest-sug-sub').textContent=p.display_address;
      var line=p.display_place+', '+p.display_address;
      wireDestPick(btn,p.lat,p.lon,line,p.display_address,getLovenRadiusProfile().city);
      destSuggestions.appendChild(btn);
    });
    destSuggestions.classList.add('open');
    destSuggestions.setAttribute('aria-hidden','false');
    var wi=getWhereInputEl();
    if(wi)wi.setAttribute('aria-expanded','true');
    positionDestSuggestions();
    requestAnimationFrame(function(){
      positionDestSuggestions();
      requestAnimationFrame(positionDestSuggestions);
    });
  }

  function runDestAutocomplete(){
    var cfg=getLiqConfig();
    var wi=getWhereInputEl();
    if(!wi)return;
    if(!cfg.token)return;
    var q=(wi.value||'').trim();
    if(q.length<2){closeDestSuggestions();return;}
    var seq=(destFetchSeq+=1);
    var liqFetchErrors=[];

    var paramsAuto=new URLSearchParams();
    paramsAuto.set('key',cfg.token);
    paramsAuto.set('q',q);
    paramsAuto.set('format','json');
    paramsAuto.set('normalizecity','1');
    paramsAuto.set('limit','15');
    paramsAuto.set('accept-language','fr');
    paramsAuto.set('importancesort','1');
    paramsAuto.set('dedupe','1');
    paramsAuto.set('addressdetails','1');
    if(cfg.countrycodes)paramsAuto.set('countrycodes',cfg.countrycodes);
    applyLiqViewboxParams(paramsAuto);

    var paramsSearch=new URLSearchParams();
    paramsSearch.set('key',cfg.token);
    paramsSearch.set('q',q);
    paramsSearch.set('format','json');
    paramsSearch.set('limit','15');
    paramsSearch.set('accept-language','fr');
    paramsSearch.set('addressdetails','1');
    paramsSearch.set('dedupe','1');
    if(cfg.countrycodes)paramsSearch.set('countrycodes',cfg.countrycodes);
    applyLiqViewboxParams(paramsSearch);

    var autoEndpoints=['https://eu1.locationiq.com/v1/autocomplete','https://api.locationiq.com/v1/autocomplete'];
    var searchEndpoints=['https://eu1.locationiq.com/v1/search','https://api.locationiq.com/v1/search'];

    function finishOk(data){
      if(seq!==destFetchSeq)return;
      if(!Array.isArray(data)||!data.length){closeDestSuggestions();return;}
      mountDestSuggestionsInWhereWrap();
      renderDestSuggestionItems(data);
      destSuggestions.classList.add('open');
      destSuggestions.setAttribute('aria-hidden','false');
      var wi2=getWhereInputEl();
      if(wi2)wi2.setAttribute('aria-expanded','true');
      positionDestSuggestions();
      requestAnimationFrame(function(){
        positionDestSuggestions();
        requestAnimationFrame(positionDestSuggestions);
      });
    }

    /**
     * search + autocomplete en parallèle puis fusion : l’autocomplete classe souvent mieux les lieux type parc / POI ;
     * le seul « search » peut remonter n’importe quel rue « Parc … » à l’étranger.
     */
    function tryHostPair(hostIdx){
      if(hostIdx>=searchEndpoints.length){
        if(seq===destFetchSeq){
          var authFail=liqFetchErrors.some(liqErrorLooksAuth);
          if(authFail){
            if(shouldShowLocationIqTechnicalUi()){
              showDestApiErrorMessage(
                'Jeton refusé par l’API LocationIQ (clé invalide ou 401). La capture « Access Tokens » avec référents Mapbox n’est pas le bon service : ce thème appelle locationiq.com. Créez un jeton sur locationiq.com → API Access Tokens, autorisez votre domaine et localhost dans les référents LocationIQ, puis collez ce jeton dans Réglages du thème → LocationIQ — pas un jeton Mapbox.'
              );
            }else{
              closeDestSuggestions();
            }
          }else{
            if(window.location.search.indexOf('loven_debug=1')!==-1){
              console.warn('[Loven] LocationIQ : search et autocomplete sans résultats (forfait, referrer, quota).');
            }
            closeDestSuggestions();
          }
        }
        return;
      }
      Promise.all([
        fetchLocationIqArray(searchEndpoints[hostIdx]+'?'+paramsSearch.toString()).catch(function(err){liqFetchErrors.push(err);return null;}),
        fetchLocationIqArray(autoEndpoints[hostIdx]+'?'+paramsAuto.toString()).catch(function(err){liqFetchErrors.push(err);return null;})
      ]).then(function(parts){
        if(seq!==destFetchSeq)return;
        var listS=parts[0]?normalizeLocationIqSearchHits(parts[0]):null;
        var listA=parts[1]?normalizeLocationIqAutocomplete(parts[1]):null;
        var merged=mergeAndRankDestHits(listS,listA,cfg);
        merged=dedupeLiqDestHits(merged);
        if(merged&&merged.length){finishOk(merged);return;}
        tryHostPair(hostIdx+1);
      }).catch(function(){
        tryHostPair(hostIdx+1);
      });
    }

    tryHostPair(0);
  }

  /** Ouvre le panneau suggestions (récent + populaires ou autocomplete selon la saisie). */
  function openDestinationSearchPanel(){
    if(isLovenMobileSearchUi())closeDates();
    mountDestSuggestionsInWhereWrap();
    var wi=getWhereInputEl();
    if(!wi)return;
    var q=(wi.value||'').trim();
    if(q.length>=2){
      var cfg=getLiqConfig();
      if(!cfg.token){showDestinationInitialPanel();return;}
      runDestAutocomplete();
      return;
    }
    showDestinationInitialPanel();
  }

  function positionDateDropdown(){
    if(!dropdown)return;
    var avail=document.getElementById('avail-search');
    var mapMobileRoot=document.getElementById('CollectionAjaxResult');
    var isEmbedMapOverlay=
      avail&&
      avail.classList.contains('loven-mobile-search-open')&&
      mapMobileRoot&&
      mapMobileRoot.classList.contains('loven-collection-map-mobile');
    var toggleEl=document.getElementById('as-toggle');
    /* Overlay plein écran : .as-bar occupe toute la hauteur → barRect.bottom poussait le calendrier hors viewport */
    if(isEmbedMapOverlay&&toggleEl){
      var tr=toggleEl.getBoundingClientRect();
      var ddWidth=dropdown.offsetWidth||Math.min(340,Math.max(280,(window.innerWidth||400)-24));
      var vpW=window.innerWidth||document.documentElement.clientWidth;
      var left=clamp(tr.left+tr.width/2-ddWidth/2,12,vpW-ddWidth-12);
      dropdown.style.left=left+'px';
      dropdown.style.top=Math.round(tr.bottom+10)+'px';
      return;
    }
    var ar=getAvailSearchEl();
    var barEl=ar?ar.querySelector('.as-bar'):null;
    if(!barEl)return;
    var barRect=barEl.getBoundingClientRect();
    var ddWidth=dropdown.offsetWidth||600;
    var vpW=window.innerWidth||document.documentElement.clientWidth;
    var centerLeft=barRect.left+(barRect.width/2)-(ddWidth/2);
    var left=clamp(centerLeft,12,vpW-ddWidth-12);
    dropdown.style.left=left+'px';
    dropdown.style.top=(barRect.bottom+12)+'px';
  }

  function positionCollectionDropdown(){
    if(!colDropdown)return;
    var wrap=document.getElementById('as-where-wrap');
    var anchor=wrap||colToggle;
    var rect=anchor.getBoundingClientRect();
    var width=Math.max(Math.round(rect.width),240);
    var viewportWidth=window.innerWidth||document.documentElement.clientWidth;
    var left=clamp(rect.left,12,viewportWidth-width-12);
    colDropdown.style.width=width+'px';
    colDropdown.style.left=left+'px';
    colDropdown.style.top=(rect.bottom+12)+'px';
  }

  function syncFloating(){
    if(dropdown&&dropdown.classList.contains('open')) positionDateDropdown();
    if(colDropdown&&colDropdown.classList.contains('open')) positionCollectionDropdown();
    if(destSuggestions.classList.contains('open')) positionDestSuggestions();
  }

  function skipMobileCollectionTitlePrefill() {
    try {
      return (
        typeof window.matchMedia !== 'undefined' &&
        window.matchMedia('(max-width: 768px)').matches &&
        document.getElementById('CollectionAjaxResult') &&
        document.getElementById('CollectionAjaxResult').classList.contains('loven-collection-map-mobile')
      );
    } catch (e) {
      return false;
    }
  }

  function hydrateCollectionFromUrl(){
    var qs = new URLSearchParams(window.location.search);
    if (qs.get('dest_label') || qs.get('dest_lat')) return;
    var path = window.location.pathname || '';
    var m = path.match(/\/collections\/([^/]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    var wi = getWhereInputEl();
    var wcb = document.getElementById('as-where-clear');
    if (handle === 'search') {
      selectedCollection = 'search';
      if (wi && !wi.value.trim()) wi.value = '';
      return;
    }
    var found = null;
    for (var i = 0; i < collections.length; i++) {
      if (collections[i].handle === handle) {
        found = collections[i];
        break;
      }
    }
    if (found) {
      selectedCollection = handle;
      if (wi && !skipMobileCollectionTitlePrefill()) {
        wi.value = found.title;
        if (wcb) wcb.hidden = !wi.value.trim();
      }
      return;
    }
    if (window.__currentCollectionHandle === handle && window.__currentCollectionTitle) {
      selectedCollection = handle;
      if (wi && !skipMobileCollectionTitlePrefill()) {
        wi.value = window.__currentCollectionTitle;
        if (wcb) wcb.hidden = !wi.value.trim();
      }
    }
  }

  function loadCollections(){
    if (window.__searchCollections) {
      collections = window.__searchCollections;
    } else {
      collections = [];
    }
    hydrateCollectionFromUrl();
    renderCollections();
  }

  function renderCollections(){
    if(!colDropdown)return;
    colDropdown.innerHTML='';
    collections.forEach(function(col){
      var btn=document.createElement('button');
      btn.className='as-col-item'+(selectedCollection===col.handle?' active':'');
      btn.innerHTML='<span class="as-check">'+(selectedCollection===col.handle?'✓':'')+'</span>'+col.title;
      btn.addEventListener('click',function(e){
        e.stopPropagation();
        selectedCollection=col.handle;
        destLat=null;
        destLon=null;
        destRadiusKm=null;
        var wi=document.getElementById('as-where-input');
        var wcb=document.getElementById('as-where-clear');
        if(wi){
          wi.value=col.title;
          if(wcb)wcb.hidden=!wi.value.trim();
        }
        colDropdown.classList.remove('open');
        if(colToggle)colToggle.setAttribute('aria-expanded','false');
        renderCollections();
      });
      colDropdown.appendChild(btn);
    });
    if(colDropdown.classList.contains('open')) positionCollectionDropdown();
  }

  function refreshDateDisplayChrome(){
    if(!display)return;
    display.classList.toggle('has-dates',!!startD);
  }

  function renderMonth(containerId,titleId,date){
    var y=date.getFullYear(),m=date.getMonth();
    document.getElementById(titleId).textContent=months[m]+' '+y;
    var container=document.getElementById(containerId);container.innerHTML='';
    var first=new Date(y,m,1),dow=(first.getDay()+6)%7;
    for(var i=0;i<dow;i++){var sp=document.createElement('span');sp.className='as-day disabled';container.appendChild(sp);}
    var days=new Date(y,m+1,0).getDate();
    var today=new Date();today.setHours(0,0,0,0);
    for(var d=1;d<=days;d++){
      var btn=document.createElement('button');btn.className='as-day';btn.textContent=d;
      var dt=new Date(y,m,d);
      if(dt<today){btn.classList.add('disabled');}
      if(sameDay(dt,startD)&&sameDay(dt,endD)){btn.classList.add('selected');}
      else if(sameDay(dt,startD)){btn.classList.add('range-start','selected');}
      else if(sameDay(dt,endD)){btn.classList.add('range-end','selected');}
      else if(startD&&endD&&dt>startD&&dt<endD){btn.classList.add('in-range');}
      (function(dd){btn.addEventListener('click',function(e){e.stopPropagation();selectDate(dd);});})(dt);
      container.appendChild(btn);
    }
  }

  function render(){
    var m2=new Date(cur.getFullYear(),cur.getMonth()+1,1);
    renderMonth('as-days-1','as-title-1',cur);
    renderMonth('as-days-2','as-title-2',m2);
    if(dropdown&&dropdown.classList.contains('open')) positionDateDropdown();
  }

  function selectDate(d){
    if(step===0){startD=d;endD=null;step=1;}
    else{if(d<startD){startD=d;endD=null;step=1;}else{endD=d;step=0;}}
    if(startD&&endD){
      if(display)display.textContent=fmtShort(startD)+' - '+fmtShort(endD);
      if(clearBtn)clearBtn.style.display='inline';
    }else{if(display)display.textContent=fmtShort(startD)+' - …';}
    refreshDateDisplayChrome();
    render();
  }

  function closeDates(){if(dropdown)dropdown.classList.remove('open');}
  function closeCollections(){
    if(colDropdown)colDropdown.classList.remove('open');
    if(colToggle)colToggle.setAttribute('aria-expanded','false');
  }
  function closeAll(){closeDates();closeCollections();closeDestSuggestions();}
  function openDates(){closeDestSuggestions();closeCollections();if(dropdown){dropdown.classList.add('open');positionDateDropdown();}}
  function openCollections(){
    closeDestSuggestions();closeDates();
    if(colDropdown)colDropdown.classList.add('open');
    if(colToggle)colToggle.setAttribute('aria-expanded','true');
    positionCollectionDropdown();
  }

  if(colToggle){
    colToggle.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      if(colDropdown&&colDropdown.classList.contains('open'))closeCollections();
      else openCollections();
    });
  }

  if(toggle){
    toggle.addEventListener('click',function(e){
      e.stopPropagation();
      if(dropdown&&dropdown.classList.contains('open')) closeDates();
      else{
        if(isLovenMobileSearchUi()){
          var wi=getWhereInputEl();
          if(wi&&document.activeElement===wi)wi.blur();
        }
        openDates();
      }
    });
  }

  var asPrev=document.getElementById('as-prev');
  var asNext=document.getElementById('as-next');
  if(asPrev){
    asPrev.addEventListener('click',function(e){e.stopPropagation();cur.setMonth(cur.getMonth()-1);render();});
  }
  if(asNext){
    asNext.addEventListener('click',function(e){e.stopPropagation();cur.setMonth(cur.getMonth()+1);render();});
  }
  if(clearBtn){
    clearBtn.addEventListener('click',function(e){
      e.stopPropagation();
      startD=null;endD=null;step=0;
      if(display)display.textContent='Quand ?';
      refreshDateDisplayChrome();
      clearBtn.style.display='none';
      render();
      var u=new URL(window.location.href);
      if(!u.searchParams.has('start')&&!u.searchParams.has('end'))return;
      u.searchParams.delete('start');
      u.searchParams.delete('end');
      u.searchParams.delete('page');
      window.location.href=withLocationHash(u.pathname+(u.search?u.search:''));
    });
  }
  var asSearchBtn=document.getElementById('as-search');
  if(asSearchBtn){
    asSearchBtn.addEventListener('click',function(e){
      e.stopPropagation();
      closeAll();
      resolveDestinationBeforeSearch().then(function(){
        var col=selectedCollection||'search';
        if(destLat!=null&&destLon!=null&&!isNaN(destLat)&&!isNaN(destLon))col='search';
        var href=buildSearchUrl(col,startD,endD);
        var cur=window.location.pathname+window.location.search+(window.location.hash||'');
        if(href===cur)window.location.reload();
        else window.location.href=href;
      });
    });
  }
  window.LovenResolveDestinationBeforeSearch=resolveDestinationBeforeSearch;
  window.LovenSearchBarOpenDates=openDates;
  window.LovenSearchBarCloseDates=closeDates;
  window.LovenSearchBarCloseAll=closeAll;
  window.LovenSearchBarOpenDestinationSearch=function(){
    var wi=getWhereInputEl();
    if(wi)wi.focus();
  };

  document.addEventListener('click',function(e){
    var target=e.target;
    var dbg=document.getElementById('loven-debug-panel');
    var availRoot=document.getElementById('avail-search');
    if(
      availRoot&&availRoot.contains(target)||
      (dropdown&&dropdown.contains(target))||
      (colDropdown&&colDropdown.contains(target))||
      destSuggestions.contains(target)||
      (dbg&&dbg.contains(target))
    )return;
    closeAll();
  });

  window.addEventListener('resize',syncFloating);
  window.addEventListener('scroll',syncFloating,true);

  function hydrateDatesFromUrl(){
    var p=new URLSearchParams(window.location.search);
    var s=p.get('start'), e=p.get('end');
    if(!s||!e)return;
    var parts=function(x){var a=x.split('-');if(a.length!==3)return null;return new Date(parseInt(a[0],10),parseInt(a[1],10)-1,parseInt(a[2],10));};
    var sd=parts(s), ed=parts(e);
    if(!sd||!ed)return;
    startD=sd; endD=ed; step=0;
    if(display)display.textContent=fmtShort(startD)+' - '+fmtShort(endD);
    refreshDateDisplayChrome();
    if(clearBtn)clearBtn.style.display='inline';
    render();
  }

  function cleanDestLabelParam(lab){
    if(!lab)return '';
    var s=String(lab).trim();
    var q=s.indexOf('?');
    if(q>=0)s=s.slice(0,q);
    var a=s.indexOf('&');
    if(a>=0)s=s.slice(0,a);
    return s.trim();
  }

  /** Corrige dest_label=Bretagne?loven_ads_debug=1 → dest_label=Bretagne&loven_ads_debug=1 */
  function sanitizePartnerAdsUrlParams(){
    try{
      var u=new URL(window.location.href);
      var lab=u.searchParams.get('dest_label');
      if(!lab)return;
      var needs=false;
      var clean=cleanDestLabelParam(lab);
      if(clean&&clean!==lab){
        u.searchParams.set('dest_label',clean);
        needs=true;
      }
      if((lab.indexOf('loven_ads_debug')>=0||u.search.indexOf('loven_ads_debug')>=0)&&!u.searchParams.has('loven_ads_debug')){
        u.searchParams.set('loven_ads_debug','1');
        needs=true;
      }
      if(needs)history.replaceState({},'',u.pathname+u.search+(window.location.hash||''));
    }catch(e){}
  }

  function hydrateDestFromUrl(){
    sanitizePartnerAdsUrlParams();
    var wi=getWhereInputEl();
    if(!wi)return;
    var p=new URLSearchParams(window.location.search);
    var lab=cleanDestLabelParam(p.get('dest_label'));
    if(lab){
      wi.value=lab;
      var wcb=document.getElementById('as-where-clear');
      if(wcb)wcb.hidden=false;
    }
    var la=p.get('dest_lat'), lo=p.get('dest_lon'), rAd=p.get('dest_radius_km');
    if(la&&lo){
      var a=parseFloat(la,10), b=parseFloat(lo,10);
      if(!isNaN(a)&&!isNaN(b)){destLat=a;destLon=b;}
    }
    if(rAd){
      var rP=parseFloat(rAd,10);
      if(!isNaN(rP)&&rP>0){destRadiusKm=clampRadiusKm(rP);}
    }else if(!la){destRadiusKm=null;}
    if(lab||la){selectedCollection='search';renderCollections();}
  }

  loadCollections();
  render();
  hydrateDatesFromUrl();
  hydrateDestFromUrl();
  document.addEventListener('collection:reloaded', function () {
    hydrateDatesFromUrl();
    hydrateDestFromUrl();
    hydrateCollectionFromUrl();
    renderCollections();
  });

  (function initLovenDebugPanel(){
    var panel=document.getElementById('loven-debug-panel');
    if(!panel)return;
    var badge=document.getElementById('loven-debug-liq-badge');
    var summary=document.getElementById('loven-debug-liq-summary');
    var out=document.getElementById('loven-debug-liq-out');
    var btn=document.getElementById('loven-debug-liq-btn');
    function maskToken(t){
      if(!t||String(t).length<4)return'(vide ou trop court)';
      var s=String(t).trim();
      return s.substring(0,Math.min(8,s.length))+'…'+s.substring(s.length-4);
    }
    function setBadge(state,txt){
      if(!badge)return;
      badge.className='loven-debug-panel__badge ';
      if(state==='wait')badge.className+='loven-debug-panel__badge--wait';
      else if(state==='ok')badge.className+='loven-debug-panel__badge--ok';
      else badge.className+='loven-debug-panel__badge--err';
      badge.textContent=txt;
    }
    function runTest(){
      var cfg=getLiqConfig();
      if(summary)summary.textContent='Jeton côté thème : '+maskToken(cfg.token);
      if(!cfg.token||!cfg.token.length){
        setBadge('err','Non configuré');
        if(out)out.textContent='[Étape 1] Aucun jeton détecté.\n\n→ Personnaliser le thème → Recherche disponibilité → Jeton LocationIQ (onglet API Access Tokens, souvent pk.…).\n→ Enregistrer le thème puis recharger la page.';
        return;
      }
      setBadge('wait','Requête…');
      if(out)out.textContent='Étape 1 : v1/search puis v1/autocomplete (même ordre que le champ Destination).';
      var paramsAuto=new URLSearchParams();
      paramsAuto.set('key',cfg.token);
      paramsAuto.set('q','Paris');
      paramsAuto.set('format','json');
      paramsAuto.set('normalizecity','1');
      paramsAuto.set('limit','3');
      paramsAuto.set('accept-language','fr');
      if(cfg.countrycodes)paramsAuto.set('countrycodes',cfg.countrycodes);
      var paramsSearch=new URLSearchParams();
      paramsSearch.set('key',cfg.token);
      paramsSearch.set('q','Paris');
      paramsSearch.set('format','json');
      paramsSearch.set('limit','3');
      paramsSearch.set('accept-language','fr');
      if(cfg.countrycodes)paramsSearch.set('countrycodes',cfg.countrycodes);
      function reportSearchOk(list){
        setBadge('ok','API OK');
        if(summary)summary.textContent='Jeton '+maskToken(cfg.token)+' — v1/search : '+list.length+' résultat(s) (priorité des suggestions).';
        if(out)out.textContent=JSON.stringify({etape1_ok:true,methode:'v1/search',note:'Utilisé en premier pour le champ Destination.',nombre_suggestions:list.length,echantillon:list.slice(0,3)},null,2);
      }
      function reportAutoOk(list){
        setBadge('ok','API OK (autocomplete)');
        if(summary)summary.textContent='Jeton '+maskToken(cfg.token)+' — v1/autocomplete : '+list.length+' (search vide ou erreur).';
        if(out)out.textContent=JSON.stringify({etape1_ok:true,methode:'v1/autocomplete',note:'Secondaire si search ne renvoie rien.',nombre_suggestions:list.length,echantillon:list.slice(0,3)},null,2);
      }
      var searchUrl='https://eu1.locationiq.com/v1/search?'+paramsSearch.toString();
      var autoUrl='https://eu1.locationiq.com/v1/autocomplete?'+paramsAuto.toString();
      fetchLocationIqArray(searchUrl)
        .then(function(data){
          var list=normalizeLocationIqSearchHits(data);
          if(list){
            reportSearchOk(list);
            return;
          }
          return fetchLocationIqArray(autoUrl).then(function(data2){
            var list2=normalizeLocationIqAutocomplete(data2);
            if(list2)reportAutoOk(list2);
            else setBadge('err','Réponses vides');
          });
        })
        .catch(function(){
          return fetchLocationIqArray(autoUrl).then(function(data2){
            var list2=normalizeLocationIqAutocomplete(data2);
            if(list2)reportAutoOk(list2);
            else throw new Error('search_empty');
          });
        })
        .catch(function(err){
          setBadge('err','Échec');
          var lines=['[Étape 1] v1/search et v1/autocomplete ont échoué.'];
          if(err&&err.httpStatus)lines.push('HTTP '+err.httpStatus);
          if(err&&err.message)lines.push(String(err.message));
          if(err&&err.body)lines.push(JSON.stringify(err.body,null,2));
          else if(err&&err.rawBody)lines.push(err.rawBody);
          lines.push('');
          lines.push('403 + Access restricted → référent HTTP : ajoutez *shopify.com* (éditeur de thème) ou l’URL exacte affichée dans F12 → Réseau → en-tête Referer.');
          lines.push('401 / jeton invalide → même jeton que le dashboard LocationIQ, compte actif, quota.');
          if(out)out.textContent=lines.join('\n');
        });
    }
    window.LovenDebugRetestLocationIq=runTest;
    if(btn)btn.addEventListener('click',runTest);
    runTest();

    var geoBadge=document.getElementById('loven-debug-geo-badge');
    var geoSummary=document.getElementById('loven-debug-geo-summary');
    var geoOut=document.getElementById('loven-debug-geo-out');
    var geoBtn=document.getElementById('loven-debug-geo-btn');
    function haversineKm(lat1,lon1,lat2,lon2){
      var R=6371;var toRad=Math.PI/180;
      var dLat=(lat2-lat1)*toRad,dLon=(lon2-lon1)*toRad;
      var a=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(lat1*toRad)*Math.cos(lat2*toRad)*Math.sin(dLon/2)*Math.sin(dLon/2);
      return R*(2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a)));
    }
    function setGeoBadge(state,txt){
      if(!geoBadge)return;
      geoBadge.className='loven-debug-panel__badge ';
      if(state==='wait')geoBadge.className+='loven-debug-panel__badge--wait';
      else if(state==='ok')geoBadge.className+='loven-debug-panel__badge--ok';
      else geoBadge.className+='loven-debug-panel__badge--err';
      geoBadge.textContent=txt;
    }
    function runDebugStep2(){
      if(!geoOut)return;
      var params=new URLSearchParams(window.location.search);
      var dLat=params.get('dest_lat'), dLon=params.get('dest_lon');
      var lab=params.get('dest_label');
      var radParam=params.get('dest_radius_km');
      var radiusKm=radParam?parseFloat(radParam,10):50;
      if(isNaN(radiusKm)||radiusKm<=0)radiusKm=50;
      var ajax=document.getElementById('CollectionAjaxContent');
      var report={
        url:window.location.href,
        params:{dest_lat:dLat||null,dest_lon:dLon||null,dest_label:lab||null,dest_radius_km:radParam||null,note_rayon:'utilisé par le filtre: '+Math.min(500,Math.max(5,radiusKm))+' km si coords présentes'},
        dates:{start:params.get('start')||null,end:params.get('end')||null},
        page_collection_html:!!ajax,
        __lovenGeoVisible:typeof window.__lovenGeoVisible==='number'?window.__lovenGeoVisible:null
      };
      if(!ajax){
        setGeoBadge('wait','Pas de grille');
        if(geoSummary)geoSummary.textContent='Ouvrez une page /collections/…';
        report.aide='Étape 2 analyse #CollectionAjaxContent — disponible sur une collection.';
        geoOut.textContent=JSON.stringify(report,null,2);
        return;
      }
      var cards=ajax.querySelectorAll('.grid-product[data-product-id]');
      var nCards=cards.length,nWithGeo=0,nGeoHidden=0;
      var samples=[];
      cards.forEach(function(card){
        if(card.classList.contains('loven-geo-hidden'))nGeoHidden++;
        var plat=card.getAttribute('data-map-lat'), plon=card.getAttribute('data-map-lon');
        if(plat&&plon)nWithGeo++;
      });
      report.cartes_total_page=nCards;
      report.cartes_avec_data_map_lat_lon=nWithGeo;
      report.cartes_classe_loven_geo_hidden=nGeoHidden;
      if(dLat&&dLon){
        var cLa=parseFloat(dLat,10), cLo=parseFloat(dLon,10);
        if(!isNaN(cLa)&&!isNaN(cLo)){
          var rMax=Math.min(500,Math.max(5,radiusKm));
          cards.forEach(function(card){
            var plat=card.getAttribute('data-map-lat'), plon=card.getAttribute('data-map-lon');
            if(!plat||!plon||samples.length>=10)return;
            var pLa=parseFloat(plat,10), pLo=parseFloat(plon,10);
            if(isNaN(pLa)||isNaN(pLo))return;
            var d=haversineKm(cLa,cLo,pLa,pLo);
            samples.push({
              id:card.getAttribute('data-product-id'),
              distance_km:Math.round(d*10)/10,
              rayon_km:rMax,
              dans_rayon:d<=rMax,
              dom_masque:card.classList.contains('loven-geo-hidden')||card.style.display==='none'
            });
          });
          report.echantillon_distances_km=samples;
        }
        if(nWithGeo===0){
          setGeoBadge('err','Sans coords produits');
          if(geoSummary)geoSummary.textContent='Aucun data-map-lat sur cette page.';
          report.aide='Renseigner les métachamps Accentuate latitude/longitude sur les produits.';
        }else if(typeof window.__lovenGeoVisible==='number'){
          setGeoBadge('ok','Filtre geo OK');
          if(geoSummary)geoSummary.textContent=window.__lovenGeoVisible+' logement(s) dans le rayon (__lovenGeoVisible).';
        }else{
          setGeoBadge('wait','En attente script');
          if(geoSummary)geoSummary.textContent='Rechargez ou cliquez « Relancer ».';
          report.note='collection-dest-filter.js définit __lovenGeoVisible après filtrage.';
        }
      }else{
        setGeoBadge('wait','Pas de GPS dans l’URL');
        if(geoSummary)geoSummary.textContent='Ajoutez dest_lat & dest_lon (recherche avec suggestion).';
        report.aide='Sans coordonnées dans l’URL, tous les logements de la page restent visibles.';
      }
      geoOut.textContent=JSON.stringify(report,null,2);
    }
    window.LovenDebugRetestGeo=runDebugStep2;
    var geoApply=document.getElementById('loven-debug-geo-apply');
    if(geoApply)geoApply.addEventListener('click',function(){
      var btn=document.getElementById('as-search');
      if(btn)btn.click();
    });
    if(geoBtn)geoBtn.addEventListener('click',function(){
      if(typeof window.LovenCollectionDestFilterRun==='function')window.LovenCollectionDestFilterRun();
      setTimeout(runDebugStep2,80);
    });
    window.addEventListener('load',function(){setTimeout(runDebugStep2,450);});
    document.addEventListener('collection:destFiltered',function(){setTimeout(runDebugStep2,30);});
    document.addEventListener('collection:reloaded',function(){setTimeout(runDebugStep2,250);});
  })();
})();

(function(){
  var root=document.getElementById('CollectionAjaxResult');
  if(!root||!root.classList.contains('loven-collection-map-mobile'))return;
  var avail=document.getElementById('avail-search');
  if(!avail||!avail.classList.contains('avail-search--embed-map'))return;

  var openBtn=document.getElementById('as-summary-open-overlay');
  var closeBtn=document.getElementById('as-mobile-overlay-close');
  var lineDest=document.getElementById('as-summary-line-dest');
  var lineDates=document.getElementById('as-summary-line-dates');
  var whereInput=document.getElementById('as-where-input');
  var disp=document.getElementById('as-display');

  function isMobileMap(){
    return typeof window.matchMedia==='function'&&window.matchMedia('(max-width: 768px)').matches;
  }

  function syncSummary(){
    if(!lineDest||!lineDates)return;
    var t=whereInput?(whereInput.value||'').trim():'';
    lineDest.textContent=t||'Rechercher une destination…';
    var dv=disp?(disp.textContent||'').replace(/\s+/g,' ').trim():'';
    lineDates.textContent=dv||'Quand ?';
    lineDest.classList.toggle('as-summary-chip__line--placeholder',!t);
  }

  function notifyLayout(){
    window.dispatchEvent(new Event('resize'));
    setTimeout(function(){ window.dispatchEvent(new Event('resize')); },80);
  }

  function openOverlay(skipWhereFocus){
    if(!isMobileMap())return;
    avail.classList.add('loven-mobile-search-open');
    document.body.classList.add('loven-mobile-search-overlay-active');
    if(openBtn)openBtn.setAttribute('aria-expanded','true');
    syncSummary();
    notifyLayout();
    if(!skipWhereFocus&&whereInput){
      whereInput.focus();
    }
  }

  function closeOverlay(){
    if(typeof window.LovenSearchBarCloseAll==='function'){
      window.LovenSearchBarCloseAll();
    }
    avail.classList.remove('loven-mobile-search-open');
    document.body.classList.remove('loven-mobile-search-overlay-active');
    if(openBtn)openBtn.setAttribute('aria-expanded','false');
    if(typeof window.LovenMeasureCollectionSearchStack==='function'){
      window.LovenMeasureCollectionSearchStack();
    }
    notifyLayout();
  }

  var formBar=document.getElementById('avail-search-form-bar');
  if(formBar){
    formBar.addEventListener('click',function(e){
      if(avail.classList.contains('loven-mobile-search-open')&&e.target===formBar)closeOverlay();
    });
  }

  if(openBtn){
    openBtn.addEventListener('click',function(e){
      e.preventDefault();
      var datesLine=document.getElementById('as-summary-line-dates');
      var clickDatesLine=datesLine&&(e.target===datesLine||!!(datesLine.contains&&datesLine.contains(e.target)));
      openOverlay(clickDatesLine);
      if(clickDatesLine){
        setTimeout(function(){
          if(typeof window.LovenSearchBarOpenDates==='function'){
            window.LovenSearchBarOpenDates();
          }
        },240);
      }
    });
  }
  if(closeBtn){
    closeBtn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      closeOverlay();
    });
  }
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&avail.classList.contains('loven-mobile-search-open'))closeOverlay();
  });
  if(whereInput)whereInput.addEventListener('input',syncSummary);
  if(whereInput)whereInput.addEventListener('change',syncSummary);
  if(disp&&typeof MutationObserver!=='undefined'){
    var mo=new MutationObserver(syncSummary);
    mo.observe(disp,{childList:true,characterData:true,subtree:true});
  }
  syncSummary();
  /*
   * Passage mobile → desktop : fermer l’overlay plein écran uniquement si ouvert.
   * Avant : if (!isMobileMap()) closeOverlay() à chaque resize desktop → closeOverlay appelait
   * LovenSearchBarCloseAll() et fermait suggestions + calendrier en boucle (lenteur, listes invisibles).
   */
  window.addEventListener('resize',function(){
    if(!isMobileMap()){
      if(avail.classList.contains('loven-mobile-search-open')||document.body.classList.contains('loven-mobile-search-overlay-active')){
        closeOverlay();
      }
      return;
    }
  });
})();

(function(){
  if(!document.querySelector('.collection-content--embedded-search'))return;
  function setStickyOffsets(){
    var header=document.querySelector('.header-section');
    var h=header?Math.round(header.getBoundingClientRect().height):76;
    /* Évite top:0 / hauteur 0 avant layout : la barre sticky se retrouve sous le header (z-index 20) et ne reçoit plus les clics. */
    if(!h||h<36){h=76;}
    var embedBar=document.querySelector('.collection-content--embedded-search > .collection-search-bar');
    var search=document.getElementById('avail-search');
    var mapMobileRoot=document.getElementById('CollectionAjaxResult');
    var isMapMobileEmbedded=
      mapMobileRoot&&
      mapMobileRoot.classList.contains('loven-collection-map-mobile')&&
      (typeof window.matchMedia!=='function'||window.matchMedia('(max-width: 768px)').matches);
    var sh=0;
    if(embedBar){
      sh=Math.round(embedBar.getBoundingClientRect().height);
    }else if(search&&search.classList.contains('avail-search--sticky')){
      sh=Math.round(search.getBoundingClientRect().height);
    }
    var gap=6;
    /* Aligné sur main-collection / main-search : top: calc(var(--loven-header-height) + 1px) pour la barre sticky desktop. */
    var searchStickyPad=document.querySelector('.collection-content--embedded-search')&&!isMapMobileEmbedded?1:0;
    if(isMapMobileEmbedded){
      document.documentElement.style.removeProperty('--loven-header-height');
    }else{
      document.documentElement.style.setProperty('--loven-header-height',h+'px');
    }
    document.documentElement.style.setProperty('--loven-map-sticky-top',(h+sh+gap+searchStickyPad)+'px');
    window.dispatchEvent(new CustomEvent('loven:sticky-offsets',{detail:{header:h,search:sh}}));
  }
  var t;
  function debounced(){
    clearTimeout(t);
    t=setTimeout(setStickyOffsets,120);
  }
  window.addEventListener('resize',debounced);
  window.addEventListener('orientationchange',debounced);
  window.addEventListener('load',debounced);
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',setStickyOffsets);
  }else{
    setStickyOffsets();
  }
  document.addEventListener('shopify:section:load',debounced);
})();
